var _path;
import * as React from "react";
function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 12.285a1.285 1.285 0 00.909-2.194l-7.714-7.714a1.285 1.285 0 00-1.818 0l-7.714 7.714a1.285 1.285 0 101.818 1.818L11 6.389v30.324a1.29 1.29 0 001.285 1.286c.707 0 1.285-.575 1.285-1.286V6.39l5.52 5.52c.25.247.58.375.909.375zm16.336 15.806a1.284 1.284 0 00-1.817-.001l-5.52 5.521V3.286c0-.71-.578-1.286-1.285-1.286s-1.286.575-1.286 1.286V33.61l-5.52-5.52a1.285 1.285 0 10-1.817 1.818l7.714 7.714a1.285 1.285 0 001.818 0l7.714-7.714a1.28 1.28 0 00-.001-1.818z"
  })));
}
export default SvgSort;